import gql from 'graphql-tag';

export default gql`
    mutation TokenLogin($input: TokenLoginInput!) {
        tokenLogin(input: $input) {
            jwtToken
        }
    }
`;